export default [
    [
        {
            role: "Software Engineer Intern",
            time: "Jan 2024 - Apr 2024",
            bullet1: "Leveraged GPT-4 & HubL to engineer content-generation features within Rich Text Editor, resulting in a 33% reduction in time spent on content creation",
            bullet2: "Developed a dynamic tier-based paywall with TypeScript, Redux, & React for HubDB facilitating the launch of Content Hub",
            bullet3: "Expanded HubDB’s versatility by implementing support for File and Call-To-Action column types increasing customer satisfaction by 12%"
        }
    ],
    [
        {
            role: "Software Developer Intern",
            time: "May 2023 - Aug 2023",
            bullet1: `Utilized AWS SQS & Lambda to implement a serverless architecture for real-time threat detection orchestrating 22 million alerts daily`,
            bullet2: "Leveraged DynamoDB Streams & AWS SNS to handle large-scale data processing and identify changes in tenants’ device health resulting in improved scalability",
            bullet3: "Developed robust REST APIs with Node.js & GraphQL pinpointing client weaknesses against cyberthreat enabling customers to promptly rectify issues and enhancing system reliability"
        }
    ],
    [
        {
            role: "Software Engineer Intern",
            time: "Jul 2020 - May 2021",
            bullet1: "Created an admin managing software to approve & review influencers and businesses during onboarding",
            bullet2: "Developed a streamlined internally connected system offering access to every company, user, and their activity in a visually simple format to improve organizational productivity and efficiency by 33%",
            bullet3: "Built AWS Lambda Functions to extract data from Cognito User Pools & MySQL database to connect with the React.js frontend using Amazon API Gateway"
        }
    ]
];